'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var blue = require('../../node_modules/@material-ui/core/esm/colors/blue.js');
var grey = require('../../node_modules/@material-ui/core/esm/colors/grey.js');
var blueGrey = require('../../node_modules/@material-ui/core/esm/colors/blueGrey.js');
var pink = require('../../node_modules/@material-ui/core/esm/colors/pink.js');
var createMuiTheme = require('../../node_modules/@material-ui/core/esm/styles/createMuiTheme.js');

var hoverColor = "rgba(33, 150, 243, 0.08)";
var styles = {
  palette: {
    primary: {
      main: '#0E6FBE',
      dark: '#0D47A1',
      light: blue[100],
      '50': blue[50],
      contrastDefaultColor: 'light'
    },
    secondary: {
      main: grey[700],
      light: grey[500],
      '400': grey[400],
      '300': grey[300],
      '200': grey[200],
      '100': grey[100],
      contrastDefaultColor: 'dark'
    },
    brandPrimary: {
      main: blueGrey[900],
      dark: blueGrey[800],
      light: blueGrey[50],
      contrastDefaultColor: 'light'
    },
    brandPrimaryLight: {
      main: blueGrey[50],
      contrastDefaultColor: 'dark'
    },
    error: {
      main: pink[600],
      light: '#F8BBD0',
      dark: '#880E4F',
      contrastDefaultColor: 'light'
    },
    alert: {
      main: '#BF8600',
      light: '#FFE082',
      dark: '#8C5400',
      contrastDefaultColor: 'dark'
    },
    warning: {
      main: '#BF8600',
      light: '#FFE082',
      dark: '#8C5400',
      contrastDefaultColor: 'dark'
    },
    info: {
      main: '#0E6FBE',
      dark: '#0D47A1',
      light: blue[100],
      '50': blue[50],
      contrastDefaultColor: 'light'
    },
    success: {
      main: '#00A344',
      light: '#B9F6CA',
      dark: '#00662B',
      contrastDefaultColor: 'dark'
    },
    action: {
      hover: blue[50],
      hoverOpacity: 0.08,
      focusOpacity: 0.16
    },
    text: {
      main: grey[900] //DO NOT USE

    },
    hover: {
      main: "rgba(33, 150, 243, 0.08)" //DO NOT USE

    },
    paper: {
      main: '#FFFFFF',
      contrastDefaultColor: 'dark'
    },
    background: {
      main: grey[50],
      white: '#FFFFFF',
      contrastDefaultColor: 'dark'
    },
    settingsColor: {
      main: "#00314a" //DO NOT USE

    },
    white: {
      main: "#FFFFFF",
      primary: "#FFFFFF",
      secondary: "rgba(255, 255, 255, .7)",
      tertiary: "rgba(255, 255, 255, .5)"
    },
    black: {
      primary: '#212121',
      secondary: "rgba(0, 0, 0, .54)",
      tertiary: "rgba(0, 0, 0, .38)" //DO NOT USE

    },
    aliceBlue: {
      main: blue[50],
      contrastDefaultColor: 'light'
    }
  },
  spacer: {
    centerContentMaxWidth: 1250
  },
  typography: {
    fontFamily: 'Open sans, Lato, Arial, sans-serif',
    caption: {
      fontSize: '0.75rem',
      lineHeight: 4 / 3,
      fontWeight: 400,
      fontStyle: 'normal'
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 11 / 7,
      fontWeight: 400,
      fontStyle: 'normal'
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
      fontWeight: 400,
      fontStyle: 'normal'
    },
    subtitle2: {
      fontSize: '1rem',
      lineHeight: 1.375,
      fontWeight: 600,
      fontStyle: 'normal'
    },
    subtitle1: {
      fontSize: '1.125rem',
      lineHeight: 4 / 3,
      fontWeight: 600,
      fontStyle: 'normal'
    },
    h6: {
      fontSize: '1.375rem',
      lineHeight: 16 / 11,
      fontWeight: 600,
      fontStyle: 'normal'
    },
    h5: {
      fontSize: '1.75rem',
      lineHeight: 20 / 14,
      fontWeight: 600,
      fontStyle: 'normal'
    },
    h4: {
      fontSize: '2.5rem',
      lineHeight: 1.2,
      fontWeight: 600,
      fontStyle: 'normal'
    },
    h3: {
      fontSize: '1.375rem',
      lineHeight: 16 / 11,
      fontWeight: 400,
      fontStyle: 'normal'
    },
    h2: {
      fontSize: '1.75rem',
      lineHeight: 20 / 14,
      fontWeight: 400,
      fontStyle: 'normal'
    },
    h1: {
      fontSize: '2.5rem',
      lineHeight: 1.2,
      fontWeight: 400,
      fontStyle: 'normal'
    },
    // eyebrow and button are not part of our design system, but we're keeping them to support old theme.
    eyebrow: {
      fontWeight: 500,
      fontSize: 12,
      lineHeight: '32px',
      letterSpacing: 1,
      color: grey[700],
      fontStyle: 'normal',
      textTransform: 'uppercase'
    },
    button: {
      fontSize: 14,
      lineHeight: 1.14,
      fontWeight: 600
    }
  },
  customShadows: {
    card: '0px 0px 12px 2px rgba(0, 0, 0, .1), 0px 0px 0px 0px rgba(0, 0, 0, .1), 0px 0px 0px 0px rgba(0, 0, 0, .1)'
  },
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: "#fff",
        cursor: 'default',
        borderBottom: 'solid 1px #e0e0e0',
        color: "rgba(0, 0, 0, .87)"
      },
      colorSecondary: {
        backgroundColor: "#00314a",
        cursor: 'default',
        color: '#fff'
      }
    },
    MuiButton: {
      root: {
        minHeight: 36
      },
      sizeSmall: {
        minHeight: 32
      },
      sizeLarge: {
        minHeight: 44
      },
      text: {
        fontFamily: 'Open sans, Lato, Arial, sans-serif'
      }
    },
    MuiTableRow: {
      root: {
        '&$selected': {
          backgroundColor: "rgba(33, 150, 243, 0.16)"
        },
        '&$hover:hover': {
          backgroundColor: hoverColor
        }
      },
      selected: {},
      hover: {}
    },
    MuiListItem: {
      button: {
        '&:hover': {
          backgroundColor: hoverColor
        }
      }
    }
  }
};
var theme = createMuiTheme(styles);

exports.styles = styles;
exports.theme = theme;
